export default "__VITE_ASSET__dnID7Nwe__"